import { FormArray, FormControl, FormGroup, UntypedFormArray, Validators } from '@angular/forms';

import { Logbook } from './crew-member-logbook.model';
import { LogbookApproachForm } from './logbook-approach-form.model';
import { AutomatedLogbookDataForm } from './automated-logbook-data-form.model';
import { AutomatedLogbookData } from './automated-logbook-data.model';

export class CrewMemberLogbookForm {
  logbookId: FormControl; //  PK
  actualInstrumentDurationMinutes: FormControl;
  dayDurationMinutes: FormControl;
  dayLandings: FormControl;
  nightDurationMinutes: FormControl;
  nightLandings: FormControl;
  dayTakeoffs: FormControl;
  nightTakeoffs: FormControl;
  // Automated Data
  automatedData: FormGroup | null;
  // flags
  isHoldPerformed: FormControl;
  isTrackPerformed: FormControl;
  // FKs
  flightCrewMemberId: FormControl;
  // collections
  logbookApproaches: FormArray;

  pilotFlightTimeMinutes: FormControl;

  pilotNonFlightTimeMinutes: FormControl;

  isTotalFlightTimePilotFlightTime: FormControl;

  totalFlightTime: FormControl;
  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(logbook?: Logbook, automatedLogbookData?: AutomatedLogbookData) {
    if (!logbook) {
      logbook = new Logbook();
    }

    this.logbookId = new FormControl(logbook.logbookId);
    this.actualInstrumentDurationMinutes = new FormControl(
      logbook.actualInstrumentDurationMinutes,
      [Validators.min(0)]
    );
    this.dayDurationMinutes = new FormControl(logbook.dayDurationMinutes);
    this.dayLandings = new FormControl(logbook.dayLandings);
    this.nightDurationMinutes = new FormControl(logbook.nightDurationMinutes, [Validators.min(0)]);
    this.nightLandings = new FormControl(logbook.nightLandings);
    if (logbook.dayTakeoffs || logbook.nightTakeoffs) {
      this.dayTakeoffs = new FormControl(logbook.dayTakeoffs);
      this.nightTakeoffs = new FormControl(logbook.nightTakeoffs);
    } else {
      this.dayTakeoffs = new FormControl(null);
      this.nightTakeoffs = new FormControl(null);
    }

    if (logbook.pilotNonFlightTimeMinutes || logbook.pilotFlightTimeMinutes) {
      this.pilotFlightTimeMinutes = new FormControl(logbook.pilotFlightTimeMinutes, [
        Validators.min(0)
      ]);
      this.pilotNonFlightTimeMinutes = new FormControl(logbook.pilotNonFlightTimeMinutes, [
        Validators.min(0)
      ]);
    } else {
      this.pilotFlightTimeMinutes = new FormControl(null, [Validators.min(0)]);
      this.pilotNonFlightTimeMinutes = new FormControl(null, [Validators.min(0)]);
    }
    this.totalFlightTime = new FormControl(logbook.totalFlightTime);
    this.isTotalFlightTimePilotFlightTime = new FormControl(
      logbook.isTotalFlightTimePilotFlightTime
    );

    // flags
    this.isHoldPerformed = new FormControl(logbook.isHoldPerformed);
    this.isTrackPerformed = new FormControl(logbook.isTrackPerformed);
    // FKs
    this.flightCrewMemberId = new FormControl(logbook.flightCrewMemberId);
    // collections
    this.createApproacheForms(logbook);

    if (logbook.automatedData) {
      this.automatedData = new FormGroup(new AutomatedLogbookDataForm(logbook.automatedData));
    }

    if (!logbook.automatedData && automatedLogbookData) {
      this.automatedData = new FormGroup(new AutomatedLogbookDataForm(automatedLogbookData));

      // When creating an empty crew member with automated data, some of the data is set as default values of the crew member.
      this.applyAutomatedData(automatedLogbookData);
    }
  }

  private createApproacheForms(logbook?: Logbook) {
    this.logbookApproaches = new UntypedFormArray([]);
    if (logbook) {
      for (const approach of logbook.logbookApproaches) {
        const approachForm = new FormGroup(new LogbookApproachForm(approach));
        this.logbookApproaches.push(approachForm);
      }
    }
  }

  private applyAutomatedData(automatedData: AutomatedLogbookData) {
    this.nightTakeoffs = new FormControl(automatedData.automatedNightTakeoffs);
    this.dayTakeoffs = new FormControl(automatedData.automatedDayTakeoffs);

    this.nightLandings = new FormControl(automatedData.automatedNightLandings);
    this.dayLandings = new FormControl(automatedData.automatedDayLandings);

    if (automatedData.automatedHoldTime) {
      this.isHoldPerformed = new FormControl(
        automatedData.automatedHoldTime !== null && automatedData.automatedHoldTime > 0
      );
    }

    if (automatedData.automatedNightFlightMinutes) {
      this.nightDurationMinutes = new FormControl(automatedData.automatedNightFlightMinutes);
    }
  }
}
